import {useEffect, useReducer, useRef} from 'react';
import classNames from 'classnames';

import Loading from '@components/Loading';
import {reducer} from '@reducers/product/list';

import {useRetailer} from '../Context/Retailer';

function checkedRetailer(props) {
	let retailer = {};
	if (props.filters.retailer) {
		let r = props.filters.retailer.split('|');
		for (let i = 0; i < r.length; i++) {
			retailer[r[i]] = true;
		}
	}
	return retailer;
}

let filterItems = null;
function Desktop(props) {
	const sliderRef = useRef({});
	const {styles} = props;
	const {retailers, loading, filters, updateFilter} = useRetailer();
	const [state, dispatch] = useReducer(reducer, {
		open: props.filters.retailer ? true : false,
		retailers: [],
	});

	useEffect(() => {
		dispatch({
			type: 'SET_DATA',
			data: {
				retailers,
			},
		});
	}, [retailers]);

	const handelCollapse = () => {
		if (state.open) {
			sliderRef.current.style.height =
				sliderRef.current.parentElement.clientHeight + 'px';
			setTimeout(() => {
				sliderRef.current.style.height = '0px';
				dispatch({
					type: 'SET_DATA',
					data: {open: !state.open},
				});
			}, 10);
		} else {
			sliderRef.current.style.height = 'auto';
			dispatch({
				type: 'SET_DATA',
				data: {open: !state.open},
			});
		}
	};

	const handleSelect = retailer => {
		let isExist = filters.find(i => i._id === retailer._id);
		let newFilter = [];
		if (isExist) {
			newFilter = [...filters.filter(i => i._id !== retailer._id)];
		} else {
			newFilter = [...filters, {...retailer, type: 'retailer'}];
		}
		updateFilter(newFilter, true);
	};

	const handleSearch = event => {
		if (filterItems) clearInterval(filterItems);
		filterItems = null;
		const val = event.currentTarget.value;
		filterItems = setInterval(() => {
			dispatch({
				type: 'SET_DATA',
				data: {
					retailers: state.retailers.map(item => ({
						...item,
						hide: val
							? !item.shop_name.toLowerCase().match(val.toLowerCase())
							: false,
					})),
				},
			});
			clearInterval(filterItems);
		}, 500);
	};

	const collapseItem = checkedRetailer(props);
	return (
		<div className={`${styles.filterListCard}`}>
			<div className={`${styles.cardHeader}`}>
				<span
					className='card-link'
					data-toggle='collapse'
					aria-expanded={state.open}
					onClick={() => handelCollapse()}
				>
					Retailer
				</span>
			</div>
			<div ref={sliderRef} className={`collapse ${state.open && 'show'}`}>
				<div className={styles.retailerFilter}>
					<div className={styles.searchFilter}>
						<button className={styles.srcIconFt}>
							<i className='fas fa-search'></i>
						</button>
						<input
							type='search'
							placeholder='Search'
							className={classNames(styles.formControl, 'form-control')}
							onChange={e => handleSearch(e)}
						/>
					</div>
					<div className={styles.checkList}>
						{loading ? (
							<Loading.ListItem length={3} />
						) : (
							<ul>
								{state.retailers.map((r, i) => {
									return (
										!r.hide && (
											<li key={i}>
												<label className='custom-check'>
													{r.shop_name}
													<input
														type='checkbox'
														checked={collapseItem[r._id] ? true : false}
														onChange={() =>
															handleSelect({_id: r._id, label: r.shop_name})
														}
													/>
													<span className='checkmark'></span>
												</label>
											</li>
										)
									);
								})}
							</ul>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

function Mobile(props) {
	const {styles} = props;
	const {retailers, loading} = useRetailer();
	const [state, dispatch] = useReducer(reducer, {
		retailers: [],
		loading,
		collapseItem: checkedRetailer({filters: props.params}),
	});

	useEffect(() => {
		dispatch({
			type: 'SET_DATA',
			data: {
				retailers,
			},
		});
	}, [retailers]);

	const handleSelect = retailer => {
		let collapseItem = {...state.collapseItem};
		collapseItem[retailer._id] = !collapseItem[retailer._id];
		let newFilter = [...retailers]
			.filter(i => collapseItem[i._id] === true)
			.map(r => ({_id: r._id, label: r.shop_name, type: 'retailer'}));

		props.setFilter(newFilter);
		dispatch({
			type: 'SET_DATA',
			data: {
				collapseItem,
			},
		});
	};

	const handleSearch = event => {
		if (filterItems) clearInterval(filterItems);
		filterItems = null;
		const val = event.currentTarget.value;
		filterItems = setInterval(() => {
			dispatch({
				type: 'SET_DATA',
				data: {
					retailers: state.retailers.map(item => ({
						...item,
						hide: val
							? !item.shop_name.toLowerCase().match(val.toLowerCase())
							: false,
					})),
				},
			});
			clearInterval(filterItems);
		}, 500);
	};

	return (
		<div className={`${styles.filterListCard}`}>
			<div className={`collapse show`}>
				<div className={styles.retailerFilter}>
					<div className={styles.searchFilter}>
						<button className={styles.srcIconFt}>
							<i className='fas fa-search'></i>
						</button>
						<input
							type='search'
							placeholder='Search'
							className={classNames(styles.formControl, 'form-control')}
							onChange={e => handleSearch(e)}
						/>
					</div>
					<div className={styles.checkList}>
						{state.loading ? (
							<Loading.ListItem length={3} />
						) : (
							<ul>
								{state.retailers.map((r, i) => {
									return (
										!r.hide && (
											<li key={i}>
												<label className='custom-check'>
													{r.shop_name}
													<input
														type='checkbox'
														checked={state.collapseItem[r._id] ? true : false}
														onChange={() =>
															handleSelect({_id: r._id, label: r.shop_name})
														}
													/>
													<span className='checkmark'></span>
												</label>
											</li>
										)
									);
								})}
							</ul>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

function Retailers(props) {
	return props.isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
}

export default Retailers;
